import { render, staticRenderFns } from "./SidebarUserMenu.vue?vue&type=template&id=2c10198e"
import script from "./SidebarUserMenu.vue?vue&type=script&lang=js"
export * from "./SidebarUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c10198e')) {
      api.createRecord('2c10198e', component.options)
    } else {
      api.reload('2c10198e', component.options)
    }
    module.hot.accept("./SidebarUserMenu.vue?vue&type=template&id=2c10198e", function () {
      api.rerender('2c10198e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/UserMenu/SidebarUserMenu.vue"
export default component.exports